export { default } from './deprecatedPropType';